<template>
  <v-card class="pa-0 h-100" elevation="0">
    <v-row class="h-100 ma-0">
      <v-col class="pa-0" style="max-width: 360px; width: 100%">
        <ServicesDirectorySidebar
          @servicesLoaded="servicesLoaded"
          @clearMarkers="clearMarkers"
          @locationSearch="handleLocationSearch"
          @locationSearchClear="handleLocationSearchClear"
        />
      </v-col>
      <v-col
        ref="mapDataContainer"
        class="pa-0"
        style="position: relative; overflow: auto"
      >
        <ServicesDirectoryMap
          ref="SDmap"
          style="z-index: 999"
          :resizeMapOnDataPanelChange="true"
          :containerHeight="mapDataContainerHeight"
          :dataPanelHeight="dataPanelHeight"
        />
        <ServicesDirectoryDataSection
          ref="dataSection"
          style="z-index: 1000"
          @sd-data-card-height="setDataPanelHeight"
          @zoomToServices="handleZoomToServices"
          @dataSectionLoaded="observeDataSectionResize"
          :containerHeight="mapDataContainerHeight"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import ServicesDirectorySidebar from "@/components/ServicesDirectorySidebar";
import ServicesDirectoryMap from "@/components/ServicesDirectoryMap";
import ServicesDirectoryDataSection from "@/components/ServicesDirectoryDataSection";
import { systemMessages } from "@/mixins/SystemMessages";

export default {
  name: "ServicesDirectory",
  mixins: [systemMessages],
  components: {
    ServicesDirectorySidebar,
    ServicesDirectoryMap,
    ServicesDirectoryDataSection,
  },
  data: () => ({
    env: process.env.VUE_APP_ENVIRONMENT,
    mapDataContainerHeight: 0,
    dataPanelHeight: 0,
    mapDataResizeObserver: null,
    dataPanelResizeObserver: null,
  }),
  mounted() {
    //send analytics event for viewing module
    this.$axios.put("/send-analytics", {
      event: "services_directory_module_visits",
    });
    this.$nextTick(function () {
      //register container and data panel resize observers after dom loaded
      this.observeMapSectionResize();
    });
  },
  beforeUnmount() {
    //unregister resize observers
    this.unobserveElementResize("mapDataContainer", "mapDataResizeObserver");
    this.unobserveElementResize("dataPanel", "dataPanelResizeObserver");
  },
  beforeRouteLeave(to, from, next) {
    // Clear selectedServices from URL when leaving the services page
    const url = new URL(window.location.href);
    if (url.searchParams.has("selectedServices")) {
      url.searchParams.delete("selectedServices");
      window.history.replaceState({}, "", url);
    }
    next();
  },
  computed: {},
  methods: {
    servicesLoaded() {
      this.$refs.SDmap.renderMapMarkers();
    },
    handleLocationSearch(locationData) {
      // Pass the location search result to the map component
      this.$refs.SDmap.zoomToLocation(locationData);
    },
    handleLocationSearchClear() {
      // Handle clearing of location search if needed
      // Could reset map to default view or clear any search-related markers
    },
    /**
     * registers observers to track container size changes and
     * update the child components so that the map and data
     * panels can be resized and fit to bounds accordingly
     */
    observeMapSectionResize() {
      this.observeElementResize(
        "mapDataContainer", //mapcontainer ref
        "mapDataResizeObserver", //this.mapDataResizeObserver
        (height) => {
          this.mapDataContainerHeight = height;
        },
      );
    },
    observeDataSectionResize() {
      this.observeElementResize(
        "dataPanel", //dataSection ref
        "dataPanelResizeObserver", //this.dataPanelResizeObserver
        (height) => {
          this.dataPanelHeight = height;
        },
      );
    },
    /**
     * Observes a DOM element for size changes using ResizeObserver.
     * @param {string} refName - Name of the ref to observe (must resolve to a DOM element or component with $el).
     * @param {string} observerKey - Data property to hold the ResizeObserver instance.
     * @param {Function} onResize - Callback that receives the element's new height.
     */
    observeElementResize(refName, observerKey, onResize) {
      const refTarget = this.$refs[refName];
      const el = refTarget?.$el || refTarget;

      if (!(el instanceof Element)) {
        console.warn(`${refName} is not a DOM element:`, el);
        return;
      }

      if (!this[observerKey]) {
        this[observerKey] = new ResizeObserver(() => {
          onResize(el.offsetHeight);
        });

        this[observerKey].observe(el);
      }
    },
    /**
     * Unregisters a ResizeObserver for a given ref.
     */
    unobserveElementResize(refName, observerKey) {
      const refTarget = this.$refs[refName];
      const el = refTarget?.$el || refTarget;

      if (this[observerKey] && el instanceof Element) {
        this[observerKey].unobserve(el);
      }
    },
    setDataPanelHeight(height) {
      /**
       * set dataPanelHeight var after it has emitted a change
       * wrapped in setTimeout to allow DOM to settle after initial
       * page load so watcher in map component can resize more accurately
       **/
      setTimeout(() => {
        this.dataPanelHeight = height;
      }, 180);
    },
    clearMarkers() {
      this.$refs.SDmap.clearMarkers();
    },
    handleZoomToServices(bounds) {
      this.$refs.SDmap.zoomToServices(bounds);
    },
  },
};
</script>

<style scoped></style>
<style>
.count-chip {
  font-size: 13px !important;
  height: 21px !important;
  min-width: 32px !important;
  padding: 0 5px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  white-space: nowrap !important;
}
</style>
